import { lazy } from 'react';
import {
    CatalogIcon,
    CmsIcon,
    HomeIcon,
    SettingsIcon,
    UsersIcon,
    ReportIcon,
    SubmittalsIcon,
    HaydonIcon,
    QuotesIcon,
} from '@/assets/images/icons';

const Dashboard = lazy(() => import('@/screens/Dashboard'));
const Catalog = lazy(() => import('@/screens/Catalog'));
const Cms = lazy(() => import('@/screens/Cms'));
const Users = lazy(() => import('@/screens/Users'));
const Customers = lazy(() => import('@/screens/Customers'));
const Reports = lazy(() => import('@/screens/Reports'));
const Settings = lazy(() => import('@/screens/Settings'));
const EditProfile = lazy(() => import('@/screens/EditProfile'));
const Submittals = lazy(() => import('@/screens/Submittals'));
const Quotes = lazy(() => import('@/screens/Quotes'));

export default [
    {
        path: '/dashboard',
        key: 'DASHBOARD',
        component: Dashboard,
        name: 'Dashboard',
        icon: <HomeIcon />,
        accessor: 'dashboard',
        subMenus: null,
        inSidebar: true,
        permissions: [],
    },
    {
        path: '/catalog/*',
        key: 'CATALOG',
        component: Catalog,
        name: 'Catalog',
        icon: <CatalogIcon />,
        accessor: 'catalog',
        permissions: ['view_productcategory', 'view_product', 'view_tableheader', 'view_productscrossreference'],
        subMenus: [
            {
                name: 'Categories',
                key: 'CATEGORIES',
                path: '/categories',
                accessor: 'categories',
                permissions: ['view_productcategory'],
            },
            {
                name: 'Products',
                key: 'PRODUCTS',
                path: '/products',
                accessor: 'products',
                permissions: ['view_product'],
            },
            {
                name: 'Technical Info Table',
                key: 'TECHNICAL-INFO-TABLE',
                path: '/technical-info-table',
                accessor: 'technical-info-table',
                permissions: ['view_tableheader'],
            },
            {
                name: 'Cross Reference',
                key: 'CROSS-REFERENCE',
                path: '/cross-reference',
                accessor: 'cross-reference',
                permissions: ['view_productscrossreference'],
            },
        ],
        inSidebar: true,
    },
    {
        path: '/submittals/*',
        key: 'SUBMITTALS',
        component: Submittals,
        name: 'Submittals',
        icon: <SubmittalsIcon />,
        accessor: 'submittals',
        subMenus: null,
        inSidebar: true,
        permissions: ['view_submittals'],
    },
    {
        path: '/quotes/*',
        key: 'QUOTES',
        component: Quotes,
        name: 'Quotes',
        icon: <QuotesIcon />,
        accessor: 'quotes',
        subMenus: null,
        inSidebar: true,
        permissions: ['view_submittals'],
    },
    {
        path: '/users/*',
        key: 'USERS',
        component: Users,
        name: 'Users',
        icon: <HaydonIcon />,
        accessor: 'users',
        permissions: ['view_memberprofile', 'view_group'],
        subMenus: [
            {
                name: 'Team Members',
                key: 'TEAM-MEMBERS',
                path: '/team-members',
                accessor: 'team-members',
                permissions: ['view_memberprofile'],
            },
            {
                name: 'Roles',
                key: 'ROLES',
                path: '/roles',
                accessor: 'roles',
                permissions: ['view_group'],
            },
        ],
        inSidebar: true,
    },
    {
        path: '/customers/*',
        key: 'CUSTOMERS',
        component: Customers,
        name: 'Customers',
        icon: <UsersIcon />,
        accessor: 'customers',
        permissions: ['view_customer', 'view_company'],
        subMenus: [
            {
                name: 'Customer',
                key: 'CUSTOMER',
                path: '/customer',
                accessor: 'customer',
                permissions: ['view_customer'],
            },
            {
                name: 'Companies',
                key: 'COMPANIES',
                path: '/companies',
                accessor: 'companies',
                permissions: ['view_company'],
            },
        ],
        inSidebar: true,
    },
    {
        path: '/cms/*',
        key: 'CMS',
        component: Cms,
        name: 'Cms',
        icon: <CmsIcon />,
        accessor: 'cms',
        permissions: ['view_haydoncmsdata', 'view_newsarticle', 'view_haydoncmsmenu'],
        subMenus: [
            {
                name: 'Pages',
                key: 'PAGES',
                path: '/pages',
                accessor: 'pages',
                permissions: ['view_haydoncmsdata'],
            },
            {
                name: 'News',
                key: 'NEWS',
                path: '/news',
                accessor: 'news',
                permissions: ['view_newsarticle'],
            },
            {
                name: 'Menus',
                key: 'MENUS',
                path: '/menus',
                accessor: 'menus',
                permissions: ['view_haydoncmsmenu'],
            },
        ],
        inSidebar: true,
    },
    {
        path: '/reports',
        key: 'REPORTS',
        component: Reports,
        name: 'Reports',
        icon: <ReportIcon />,
        accessor: 'reports',
        subMenus: null,
        inSidebar: true,
        permissions: [],
    },
    {
        path: '/settings/*',
        key: 'SETTINGS',
        component: Settings,
        name: 'Settings',
        icon: <SettingsIcon />,
        accessor: 'settings',
        permissions: ['view_generaloptions'],
        subMenus: [
            {
                name: 'General Info',
                key: 'GENERAL-INFO',
                path: '/general-info',
                accessor: 'general-info',
                permissions: ['view_generaloptions'],
            },
            {
                name: 'Configurations',
                key: 'CONFIGURATIONS',
                path: '/configurations',
                accessor: 'configurations',
                permissions: ['view_generaloptions'],
            },
            {
                name: 'Email logs',
                key: 'EMAIL-LOGS',
                path: '/email-logs',
                accessor: 'email-logs',
                permissions: ['view_generaloptions'],
            },
            {
                name: 'Hubspot',
                key: 'HUBSPOT',
                path: '/hubspot',
                accessor: 'hubspot',
                permissions: ['view_generaloptions'],
            },
            {
                name: 'Submittal Cover Page',
                key: 'SUBMITTAL-COVER-PAGE',
                path: '/submittal-cover-page',
                accessor: 'submittal-cover-page',
                permissions: ['view_generaloptions'],
            },
        ],
        inSidebar: true,
    },
    {
        path: '/profile',
        key: 'PROFILE',
        component: EditProfile,
        name: 'Profile',
        accessor: 'profile',
        subMenus: null,
        inSidebar: false,
        permissions: [],
    },
];
